import { ConnectDropTarget, useDrop } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { DragSourceType } from 'const';
import { dropStoryCard } from 'containers/Artboards/actions';
import { StoryCardDragObject } from 'models';

type ArtboardDropTargetHook = {
  connectDropTarget: ConnectDropTarget;
  isOver: boolean;
};

export const useArtboardDropTarget = (): ArtboardDropTargetHook => {
  const dispatch = useDispatch();
  const [{ isOver }, connectDropTarget] = useDrop({
    accept: [DragSourceType.STORY_CARD],
    drop: (_, monitor) => {
      const { storyCardId, screenOrder } = monitor.getItem() as StoryCardDragObject;
      dispatch(dropStoryCard(storyCardId, screenOrder));
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
    }),
  });

  return {
    connectDropTarget,
    isOver,
  };
};
